import type { DomainMapper } from '../types';

const no: DomainMapper = {
  countryCode: 'no',
  currency: 'NOK',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/NO.svg',
  languagePrimary: true,
  locale: 'no',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-no.xml',
  storyblokBasePath: 'no',
  url: 'https://localhost:3011/no',
  algoliaIndex: 'b2b-no-nb-NO-products',
  algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1352,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1352,
    algoliaIndex: 'b2b-no-nb-NO-products',
    algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-no.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1469,
    algoliaIndex: 'b2c-no-nb-NO-products',
    algoliaIndexAutocomplete: 'b2c-no-nb-NO-products_query_suggestions',
    displayIncVat: true,
    default: false,
    productBasePath: 'produkt',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-no-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default no;
